// store.js
import { configureStore } from "@reduxjs/toolkit";
import supportportalLoginReducer from "./supportportalLoginSlice";
import userSlice from "./userSlice";
import createUserReducer from "./createUserSlice";
import roleReducer from "./roleSlice";
import digitalPriceReducer from "./digitalPriceSlice";
import passwordResetReducer from "./passwordResetSlice";
import digitalPriceExcelReducer from "./digitalPriceExcelSlice";
import resourceReducer from "./resourceSlice";
import managePackageReducer from "./managePackageSlice";
import productsReducer from "./productsSlice";
import productReducer from "./productSlice";
import packagesReducer from "./packagesSlice";
import packageReducer from "./packageSlice";
import manageCampaignReducer from './manageCampaignSlice';
import orderManagementReducer from "./orderQuerySlice";
import esimQueryReducer from "./esimQuerySlice";

const store = configureStore({
  reducer: {
    supportportalLogin: supportportalLoginReducer,
    users: userSlice,
    createUser: createUserReducer,
    roles: roleReducer,
    digitalPrice: digitalPriceReducer,
    passwordReset: passwordResetReducer,
    digitalPriceExcel: digitalPriceExcelReducer,
    resources: resourceReducer,
    managePackage: managePackageReducer,
    productList: productsReducer,
    product: productReducer,
    packageList: packagesReducer,
    package: packageReducer,
    manageCampaign: manageCampaignReducer,
    orderQuery: orderManagementReducer,
    esimQuery: esimQueryReducer,
  },
});

export default store;
